import { ForwardedRef, forwardRef } from 'react';

import { TextField, TextFieldProps } from '../TextField/TextField';

export type EmailFieldProps = TextFieldProps;

export const EmailField = forwardRef(function EmailField(
  { required, ...rest }: EmailFieldProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  return (
    <TextField
      rules={{
        pattern: {
          message: 'Invalid email address',
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        },
        required: required ? 'This field is required' : false,
      }}
      {...rest}
      type="email"
      ref={ref}
      data-testid="email-field"
    />
  );
});
